export const convertNewlinesToHtml = (text: string): string => {
  if (!text) return '';
  return text.replace(/\n/g, '<br>');
};

export const convertHtmlToNewLines = (text: string): string => {
  if (!text) return '';
  return text.replace(/<br\s*\/?>/g, '\n');
};
